import React, { useState, useContext } from 'react';
import styles from './typeChangeBtnGroup.less?modules';
import { isEmptyObject } from '@/utils/comUtil';
import { ThemeContext } from 'styled-components';
import { CycleChangeMLStyled } from './CycleChangeMLStyled';

const CycleChangeML = (props) => {
  const [check, setCheck] = useState(null);
  const [checkedIndex, setCheckedIndex] = useState(0);
  const themeContext = useContext(ThemeContext);
  const handleChange = (i, v) => {
    setCheck(v);
    setCheckedIndex(i);
    props.change && props.change(v);
  };
  const { typeList } = props;
  return (
    <div className={styles.dimSwitch}>
      {!isEmptyObject(typeList) &&
        typeList.map((item, i) => {
          return (
            <CycleChangeMLStyled
              theme={themeContext}
              className={styles.box}
              key={i}
            >
              <label
                className={checkedIndex === i ? 'checked' : 'unchecked'}
                key={i}
                // style={{cursor:item.disabled===true?'':'pointer'}}
              >
                <input
                  type="radio"
                  name="type"
                  value={item.value}
                  checked={check === item.value}
                  onChange={() => {
                    handleChange(i, item.value);
                  }}
                />
                {item.label}
              </label>
            </CycleChangeMLStyled>
          );
        })}
    </div>
  );
};
export default CycleChangeML;
